import { CommonData } from "../../../datastructures/gamestate/gameData";

export class GameRoundDisplay {
  private parent = new PIXI.Container();
  private gameRoundNumberDisplay: PIXI.Text;
  constructor(
    parent: PIXI.Container,
    textFontName: string | string[] = ["Tahoma, Helvetica, sans-serif"]
  ) {
    parent.addChild(this.parent);

    let bodyTextStyle = new PIXI.TextStyle({
      fontFamily: textFontName,
      strokeThickness: 4,
      stroke: 0x000000,
      fill: 0xffffff,
      fontSize: 18,
      align: "center",
    });
    this.gameRoundNumberDisplay = new PIXI.Text("", bodyTextStyle);
    this.gameRoundNumberDisplay.anchor.set(0, 0.5);
    this.gameRoundNumberDisplay.alpha = 0.5;
    this.parent.addChild(this.gameRoundNumberDisplay);
  }
  public updateGameRound(newText: string, activegameData: CommonData): void {
    if (newText != undefined) {
      this.gameRoundNumberDisplay.text = "ROUND ID: " + newText;

      const { isDemo, replayMode, InspectReplay } = activegameData;
      const needToHide = isDemo || replayMode || InspectReplay;

      if (this.gameRoundNumberDisplay.text === "0" || needToHide) {
        this.setVisible(false);
      } else {
        this.setVisible(true);
      }
    }
  }

  public setVisible = (bool: boolean): void => {
    this.parent.visible = bool;
  };
}
